var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BCXMarkdown',{staticClass:"bc-info-help-text",class:{'is-open': _vm.isOpenVM},attrs:{"tag":_vm.tag,"text":_vm.text},on:{"open-help":function($event){_vm.isOpenVM=true}}})
}
var staticRenderFns = []

export { render, staticRenderFns }